import Users from '@/components/users/Users'
import CreateUser from '@/components/users/Create'
import Enum from '@/shared/enum'

let usersRoutes = [
  {
    meta: {
      title: 'menu.users',
      ico: 'user',
      permission: ['Pages.Users'],
    },
    path: '/users',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'users',
        path: '',
        meta: {permission: ['Pages.Users.View']},
        component: Users,
      },
      {
        name: 'users_create',
        path: 'create',
        meta: {permission: ['Pages.Users.Create']},
        props: {compMode: Enum.Mode.CREATE},
        component: CreateUser,
      },
      {
        name: 'users_edit',
        path: 'edit/:id',
        meta: {permission: ['Pages.Users.Create']},
        props: {compMode: Enum.Mode.UPDATE},
        component: CreateUser,
      },
    ],
  },
]

export default usersRoutes



// WEBPACK FOOTER //
// ./src/router/users.js